<template>
  <a-row :gutter="10">
    <a-modal
      title="版本记录"
      :width="800"
      :visible="historyListVisible"
      @ok="historyListVisible = false"
      @cancel="historyListVisible = false"
      style="z-index: 9"
    >
      <a-table
        style="height: 500px"
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="historyColumns"
        :dataSource="historyListdataSource"
        :loading="loading"
      >
        <span slot="downTime" slot-scope="text">
          <span v-if="text"> {{ text }}</span>
          <span v-else> -</span>
        </span>
        <span slot="status" slot-scope="text">
          <a-tag v-if="text == 1" color="grey"> 待启用</a-tag>
          <a-tag v-else-if="text == 2" color="green"> 启用</a-tag>
          <a-tag v-else color="red"> 停用</a-tag>
        </span>
        <span slot="action" slot-scope="text, record, index">
          <a @click="look(record, index)">预览</a>
        </span>
      </a-table>
    </a-modal>
    <a-modal title="启用" :width="800" :visible="qyVisible" @cancel="qyVisible = false">
      <template slot="footer">
        <a-button @click="qyVisible = false">取消</a-button>
        <a-popconfirm title="此操作将启用专家库，是否继续?" @confirm="() => handleOk()">
          <a-button :loading="loading" type="primary">启用</a-button>
        </a-popconfirm>
      </template>

      <a-form-model ref="ruleForm" :model="paramss">
        <a-form-model-item
          label="启用时间"
          ref="enableTime"
          prop="enableTime"
          :rules="{
            required: true,
            message: '请选择启用时间',
            trigger: 'change'
          }"
        >
          <a-date-picker
            v-model="paramss.enableTime"
            placeholder="请选择时间"
            :show-time="{ format: 'HH:mm:ss' }"
            valueFormat="YYYY-MM-DD HH:mm:ss"
            style="width: 100%"
            :disabled-date="disabledDate"
            :disabled-time="disabledTime"
            @openChange="handleOpenChange"
            :getCalendarContainer="(triggerNode) => triggerNode.parentNode"
          />
        </a-form-model-item>
        <p style="color: red" v-if="openType !== 'add'">
          注:组建评标委员会(资审委员会)的时间在启用时间之后的项目可选择此专家库。
        </p>
      </a-form-model>
    </a-modal>
    <a-col :sm="24" style="margin-bottom: 20px">
      <a-card :bordered="false">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <!-- 搜索区域 -->
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :span="6">
                <a-form-item label="专家库名称">
                  <a-input placeholder="请输入专家库名称" v-model.trim="queryParam.expertLibraryName"></a-input>
                </a-form-item>
              </a-col>

              <a-col :md="6" :sm="8">
                <a-form-item label="状态">
                  <a-select placeholder="请选择状态" v-model="queryParam.status">
                    <a-select-option value>请选择</a-select-option>
                    <a-select-option v-for="d in data" :key="d.value">{{ d.name }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="创建人">
                  <a-input placeholder="请输入创建人" v-model.trim="queryParam.createName"></a-input>
                </a-form-item>
              </a-col>

              <a-col :span="6">
                <a-form-item label="创建时间">
                  <a-range-picker
                    v-model="queryParams.createTime"
                    format="YYYY-MM-DD"
                    :placeholder="['开始时间', '结束时间']"
                    @change="onBirthdayChange"
                  />
                </a-form-item>
              </a-col>
              <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
                <a-col :md="12" :sm="24">
                  <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
                  <a-button type="primary" @click="searchResetOther" icon="reload" style="margin-left: 8px"
                    >重置</a-button
                  >
                </a-col>
              </span>
            </a-row>
          </a-form>
        </div>
        <!-- 操作按钮区域 -->
        <div class="table-operator" style="margin: 5px 0 10px 2px">
          <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
          <!--<a-button @click="handleEdit(model1)" type="primary" icon="plus">角色编辑</a-button>-->
          <!-- <a-upload
            name="file"
            :showUploadList="false"
            :multiple="false"
            :headers="tokenHeader"
            :action="importExcelUrl"
            @change="handleImportExcel"
          >
            <a-button type="primary" icon="import">导入</a-button>
          </a-upload>
          <a-button type="primary" icon="download" @click="handleExportXls('角色管理')">导出</a-button> -->
        </div>
        <div style="margin-top: 15px">
          <a-table
            style="height: 500px"
            ref="table"
            size="middle"
            bordered
            rowKey="id"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="ipagination"
            :loading="loading"
            @change="handleTableChange"
          >
            <span slot="changeName" slot-scope="text">
              <span v-if="text"> {{ text }}</span>
              <span v-else> -</span>
            </span>
            <span slot="changeTime" slot-scope="text">
              <span v-if="text"> {{ text }}</span>
              <span v-else> -</span>
            </span>
            <span slot="status" slot-scope="text, record">
              <a-tag v-if="text == 1" color="grey"> 待启用</a-tag>
              <a-tag v-else-if="text == 2" color="green"> 启用</a-tag>
              <a-tag v-else color="red"> 停用</a-tag>
            </span>
            <span slot="action" slot-scope="text, record">
              <a @click="qyVisibleShow(record, true)" v-if="record.status != 2">启用</a>

              <a-popconfirm title="此操作将停用专家库，是否继续?" @confirm="() => handleOk(3)">
                <a @click="qyVisibleShow(record, false)" v-if="record.status == 2">停用</a>
              </a-popconfirm>
              <a @click="handleEdit(record)" style="margin: 0 10px">编辑</a>
              <a @click="historyList(record)">版本记录</a>
            </span>
          </a-table>
        </div>
        <!-- 右侧的角色权限配置 -->
        <user-role-modal ref="modalUserRole"></user-role-modal>
        <addZJKModal ref="modalForm" @ok="modalFormOk"></addZJKModal>
      </a-card>
    </a-col>
  </a-row>
</template>
<script>
import JDate from '@/components/jeecg/JDate.vue'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { deleteAction, postAction, getAction, api } from '@/api/manage'
import { FileUpload, sysInfoall, getRoleUserList } from '@/api/api'
import SelectUserModal from './modules/SelectUserModal'
import addZJKModal from './modules/addZJKModal'
import { filterObj } from '@/utils/util'
import UserRoleModal from './modules/UserRoleModal'
import moment from 'moment'
export default {
  name: 'RoleUserList',
  mixins: [JeecgListMixin],
  components: {
    UserRoleModal,
    SelectUserModal,
    addZJKModal,
    moment,
    JDate
  },
  data() {
    return {
      now: moment(), // 保存当前时间用于计算
      historyListdataSource: [],
      needData: null,
      paramss: { enableTime: null },
      qyVisible: false,
      historyListVisible: false,
      appid: '',
      model1: {},
      model2: {},
      currentRoleId: '',
      queryParam1: {},
      queryParam2: {},
      queryParams: {},
      dataSource: [],
      dataSource1: [],
      dataSource2: [],
      data: [
        {
          name: '待启用',
          value: 1
        },
        {
          name: '启用',
          value: 2
        },
        {
          name: '停用',
          value: 3
        }
      ],
      ipagination1: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      ipagination2: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      isorter1: {
        column: 'createTime',
        order: 'desc'
      },
      isorter2: {
        column: 'createTime',
        order: 'desc'
      },
      filters1: {},
      filters2: {},
      loading1: false,
      loading2: false,
      test: {},
      rightcolval: 0,
      historyColumns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          title: '状态',
          dataIndex: 'status',
          align: 'center',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '版本',
          align: 'center',
          dataIndex: 'version'
        },
        {
          title: '创建人',
          align: 'center',
          dataIndex: 'createName'
        },
        {
          title: '创建时间',
          align: 'center',
          dataIndex: 'createTime'
        },
        {
          title: '停用时间',
          align: 'center',
          dataIndex: 'downTime',
          scopedSlots: { customRender: 'downTime' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ],
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          title: '专家库名称',
          align: 'center',
          dataIndex: 'expertLibraryName'
        },
        {
          title: '状态',
          dataIndex: 'status',
          align: 'center',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '启用时间',
          dataIndex: 'enableTime',
          align: 'center'
        },
        {
          title: '创建人',
          align: 'center',
          dataIndex: 'createName'
        },
        {
          title: '创建时间',
          align: 'center',
          dataIndex: 'createTime'
        },
        {
          title: '变更人',
          align: 'center',
          dataIndex: 'changeName',
          scopedSlots: { customRender: 'changeName' }
        },
        {
          title: '变更时间',
          align: 'center',
          dataIndex: 'changeTime',
          scopedSlots: { customRender: 'changeTime' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        list: '/api/sysexpertlibraryallocation/list',
        delete: '/api/sys/role/delete',
        list2: '/api/sys/user/userRoleList',
        addUserRole: '/api/sysexpertlibraryallocation/updatEnableStatus',
        delete2: '/api/sys/user/deleteUserRole',
        deleteBatch2: '/api/sys/user/deleteUserRoleBatch',
        exportXlsUrl: '/api/sys/role/exportXls',
        importExcelUrl: '/api/sys/role/importExcel'
      }
    }
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    }
  },

  created() {},
  methods: {
    moment,
    // 更新当前时间，确保每次打开选择器时获取最新时间
    handleOpenChange(open) {
      if (open) {
        this.now = moment()
      }
    },

    // 禁用今天之前的日期
    disabledDate(current) {
      return current && current < this.now.startOf('day')
    },

    disabledTime(current) {
      return {
        disabledHours: () => this.getDisabledHours(current || moment(new Date())),
        disabledMinutes: () => this.getDisabledMinutes(current || moment(new Date())),
        disabledSeconds: () => this.getDisabledSeconds(current || moment(new Date()))
      }
    },
    getDisabledHours(date) {
      const hours = []
      for (let i = 0; i < 24; i++) {
        if (moment().isAfter(date.clone().hour(i))) {
          hours.push(i)
        }
      }
      return hours
    },
    getDisabledMinutes(date) {
      const minutes = []
      for (let i = 0; i < 60; i++) {
        if (moment().isAfter(date.clone().minute(i))) {
          minutes.push(i)
        }
      }
      return minutes
    },
    getDisabledSeconds(date) {
      const seconds = []
      for (let i = 0; i < 60; i++) {
        if (moment().isAfter(date.clone().second(i))) {
          seconds.push(i)
        }
      }
      return seconds
    },
    searchResetOther() {
      this.queryParam = {}
      this.queryParams = {}
      this.loadData()
    },
    onBirthdayChange(value, dateString) {
      this.queryParam.createTimeBegin = dateString[0]
      this.queryParam.createTimeEnd = dateString[1]
    },
    historyList(data) {
      this.historyListVisible = true
      getAction('/api/sysexpertlibraryallocationhistory/list', { libraryAllocationId: data.id }).then((res) => {
        if (res.success) {
          this.historyListdataSource = res.result
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    qyVisibleShow(record, flag) {
      this.paramss.enableTime = null
      this.qyVisible = flag
      this.needData = record
    },
    handleOk(data) {
      if (this.paramss.enableTime == null && !data) {
        return this.$message.warning('请选择启用时间')
      }
      this.$set(this.needData, 'status', data == 3 ? 3 : 2)
      this.$set(this.needData, 'enableTime', this.paramss.enableTime)
      postAction(this.url.addUserRole, this.needData).then((res) => {
        if (res.success) {
          if (data) {
            this.$message.success('停用成功')
          } else {
            this.qyVisible = false
            this.$message.success('启用成功')
          }
          this.loadData()
          this.qyVisible = false
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    look(record, index) {
      this.$refs.modalForm.title = '预览'
      this.$refs.modalForm.disabled = true
      this.$refs.modalForm.edit(record, index, true)
    },
    handleDelete1: function (id) {
      this.handleDelete(id)
      this.dataSource2 = []
      this.currentRoleId = ''
    },
    handleDelete2: function (id) {
      if (!this.url.delete2) {
        this.$message.error('请设置url.delete2属性!')
        return
      }
      var that = this
      deleteAction(that.url.delete2, { roleId: this.currentRoleId, userId: id }).then((res) => {
        if (res.success) {
          that.$message.success(res.message)
          that.loadData2()
        } else {
          that.$message.warning(res.message)
        }
      })
    },
    batchDel2: function () {
      if (!this.url.deleteBatch2) {
        this.$message.error('请设置url.deleteBatch2属性!')
        return
      }
      if (this.selectedRowKeys2.length <= 0) {
        this.$message.warning('请选择一条记录！')
        return
      } else {
        var ids = ''
        for (var a = 0; a < this.selectedRowKeys2.length; a++) {
          ids += this.selectedRowKeys2[a] + ','
        }
        var that = this
        console.log(this.currentDeptId)
        this.$confirm({
          title: '确认删除',
          content: '是否删除选中数据?',
          onOk: function () {
            deleteAction(that.url.deleteBatch2, { roleId: that.currentRoleId, userIds: ids }).then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                that.loadData2()
                that.onClearSelected()
              } else {
                that.$message.warning(res.message)
              }
            })
          }
        })
      }
    },

    handleAddUserRole() {
      if (this.currentRoleId == '') {
        this.$message.error('请选择一个角色!')
      } else {
        this.$refs.selectUserModal.visible = true
      }
    },
    handleOpen(record) {
      this.rightcolval = 1
      this.model1 = Object.assign({}, record)
      this.currentRoleId = record.id
      this.onClearSelected2()
      this.loadData2()
    },
    handleEdit(record) {
      this.$refs.modalForm.edit(record, 0, false)
      this.$refs.modalForm.title = '编辑'
    },
    searchQuery2() {
      this.loadData2(1)
    },
    searchReset2() {
      this.queryParam2 = {}
      this.loadData2(1)
    },
    handleTableChange2(pagination, filters, sorter) {
      //分页、排序、筛选变化时触发
      //TODO 筛选
      if (Object.keys(sorter).length > 0) {
        this.isorter2.column = sorter.field
        this.isorter2.order = 'ascend' == sorter.order ? 'asc' : 'desc'
      }
      this.ipagination2 = pagination
      this.loadData2()
    },
    handlePerssion(roleId, appId) {
      this.$refs.modalUserRole.show(roleId, appId)
    }
  }
}
</script>
<style scoped>
/** Button按钮间距 */
.ant-btn {
  margin-left: 8px;
}
</style>
